import GroupVoucher from '@/pages/hotel/upselling/GroupVoucher'
import GroupVoucherCart from '@/pages/hotel/upselling/GroupVoucherCart'
import GroupVoucherBookingResult from '@/pages/hotel/upselling/GroupVoucherBookingResult'
import GroupVoucherFormData from '@/pages/hotel/upselling/GroupVoucherFormData'

const emptyView = {template: '<router-view></router-view>'} 
export default {
  path: 'upselling',
  name: 'GroupVoucher',
  component: emptyView,
  children: [
    {
      path: 'cart',
      name: 'GroupVoucherCart',
      component: GroupVoucherCart,
      meta:{
        module_type: 'merchant-hotel-upselling',
        resolveInComponent: true
      }
    },
    {
      path: 'booking-result/:tx_order_id',
      name: 'GroupVoucherBookingResult',
      component: GroupVoucherBookingResult,
      meta:{
        module_type: 'merchant-hotel-upselling',
        title: 'Voucher Booking Result'
      }
    },
    {
      path: 'form-data/:tx_order_id',
      name: 'GroupVoucherFormData',
      component: GroupVoucherFormData,
      meta:{
        module_type: 'merchant-hotel-upselling',
        title: 'Voucher Product Detail Data'
      }
    },
    {
      path: ':id',
      name: 'GroupVoucher',
      component: GroupVoucher,
      meta:{
        module_type: 'merchant-hotel-upselling',
        resolveInComponent: true
      }
    }
  ]
}


// WEBPACK FOOTER //
// ./src/router/modules/merchant/hotel/Upselling.js